import PropTypes from 'prop-types';

// Utils
import { cn } from '@repo/zolintra-utils';

// Hooks
import useSticky from 'staff-management/src/hooks/useSticky';

// Styles
import usePost from 'staff-management/src/hooks/domain/usePost';
import styles from './Calendar.module.css';

// Components
import PlanningHeaderCell from '../PlanningHeaderCell/PlanningHeaderCell';
import CalendarRow from './CalendarRow';

function buildDaysMonth(month, year, getSlotsIdFromDate) {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const days = [];

  const slots = {};

  for (let day = 1; day <= daysInMonth; day += 1) {
    const date = new Date(year, month, day);
    const dayOfWeek = date.getDay();

    // Remove weekends
    if (dayOfWeek !== 6 && dayOfWeek !== 0) {
      const { startSlotId, endSlotId } = getSlotsIdFromDate(date);

      days.push({
        day,
        dayOfWeek,
        date,
        month,
        year,
      });

      slots[startSlotId] = { column: days.length, time: 'am' };
      slots[endSlotId] = { column: days.length, time: 'pm' };
    }
  }

  return {
    days,
    slots,
  };
}

export function Calendar({
  month, year, resourcesList, handleDayClick, isDayClickDisabled, monthSelector, children,
}) {
  const { getSlotsIdFromDate } = usePost();
  const { days, slots } = buildDaysMonth(month, year, getSlotsIdFromDate);
  const {
    ref: stickyRef,
    isSticky,
  } = useSticky({ rootMargin: '-125px' });

  return (
    <div className={styles.container}>
      <div className={styles.gridContainer}>

        <div
          ref={stickyRef}
          className={cn([styles.gridRow, styles.stickyRow])}
          style={{
            gridTemplateColumns: `var(--size-res-id) repeat(${days.length}, 1fr)`,
          }}
        >
          <div className={styles.emptyRow}>
            {isSticky ? monthSelector : null}
          </div>
          {days.map((day, index) => (
            <div
              key={`${day.year}-${day.month}-${day.day}`}
              className={cn([styles.gridCell, styles.cellDay, styles.dayName])}
              style={{
                gridColumn: `${index + 2} / ${index + 2}`,
              }}
            >
              <PlanningHeaderCell date={day.date} />
            </div>
          ))}
        </div>

        {resourcesList?.map((resource) => (
          <CalendarRow
            days={days}
            key={resource.id}
            handleDayClick={(dates) => handleDayClick(dates, resource)}
            resource={resource}
            isDayClickDisabled={(day) => isDayClickDisabled({ resource, day })}
          >
            {() => children(resource.id, slots)}
          </CalendarRow>
        ))}

      </div>
    </div>
  );
}

Calendar.propTypes = {
  month: PropTypes.number.isRequired,
  year: PropTypes.string.isRequired,
  resourcesList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleDayClick: PropTypes.func.isRequired,
  isDayClickDisabled: PropTypes.func.isRequired,
  monthSelector: PropTypes.node,
  children: PropTypes.func.isRequired,
};

Calendar.defaultProps = {
  monthSelector: null,
};

export default Calendar;
